import React, { MouseEvent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Datatable, { PagingTypeEnum } from '../Datatable/Datatable';
import DatatableColumnModel from '../Datatable/DatatableColumnModel';
import { setSelectedPortId, setSelectedPortIndex, setTriggerRefreshTable, portManagerSelector, setPortInput, setPortSearchText, setPorts, setOrderBy, setOrderDirection } from './reducers/PortInputReducer';
import _ from 'lodash';
import PortModel from '../PortSelector/models/PortModel';
import { OrderDirection } from '../Datatable/OrderDirection';
import { Button, Tooltip } from '@mui/material';
import Swal from 'sweetalert2';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import PortSelectorApi, { DeletePortParam } from '../PortSelector/api/PortSelectorApi';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';

const PortManagementTable: React.FunctionComponent = () => {
    let dispatch = useDispatch();

    let portManagementData = useSelector(portManagerSelector);

    const columns = [
        {
            Field: "name",
            Title: "Name",
            AllowSort: true,
        } as DatatableColumnModel<PortModel>,
        {
            Field: "area",
            Title: "Area",
            AllowSort: true,
        } as DatatableColumnModel<PortModel>,
        {
            Field: "masterArea",
            Title: "Master Area",
            AllowSort: true,
        } as DatatableColumnModel<PortModel>,
        {
            Field: "",
            Title: "",
            AllowSort: false,
            Render: (rowData: PortModel) => (
                <>
                    <Tooltip title="Delete Port">
                        <Button
                            className='table-action-button'
                            variant='outlined'
                            color='error'
                            onClick={() => {
                                deletePort(rowData.id)
                            }}
                        >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                        </Button>
                    </Tooltip>
                </>
            )
        } as DatatableColumnModel<PortModel>,
    ];

    const getTableClassName = () => {
        let className = "port-management-datatable-search-result nice-scroll";

        if (!portManagementData.inputExpand) {
            className += " port-management-datatable-search-result-input-collapse";
        }

        return className;
    }

    const deletePort = (id: number) => {
        Swal.fire({
            title: 'Are you sure want to delete this cargo tpe? This action can not be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(showLoading(true));
                PortSelectorApi.Delete({
                    id: id
                } as DeletePortParam)
                    .then((response: BaseResponse<string>) => {
                        if (response.success) {
                            Utility.Alert.Success("Cargo type deleted successful");

                            dispatch(showLoading(false));

                            dispatch(setTriggerRefreshTable(new Date().getTime()));
                        }
                    });
            }
        })
    };

    useEffect(() => {
        dispatch(setTriggerRefreshTable(new Date().getTime()));
    }, []);

    return <div className='port-datatable-wrapper'>
        <Datatable<PortModel>
            useDefaultSearchBar={true}
            onSearchValueChange={(value: string) => {
                dispatch(setPortSearchText(value));
                dispatch(setTriggerRefreshTable(new Date().getTime()))
            }}
            pagingType={PagingTypeEnum.None}
            data={portManagementData.ports}
            useItemPerPage={false}
            columns={columns}
            isDataLoaded={true}
            className={getTableClassName()}
            useHeaderSort={true}
            onOrderDirectionChange={(column: DatatableColumnModel<PortModel>, orderDirection: OrderDirection) => {
                dispatch(setOrderBy(column.Field));
                dispatch(setOrderDirection(orderDirection));

                let data = [...portManagementData.ports];
                if (orderDirection == OrderDirection.Asc) {
                    data = _.sortBy(data, column.Field);
                } else {
                    data = _.sortBy(data, column.Field).reverse();
                }

                dispatch(setPorts(data));
            }}
            orderColumn={portManagementData.orderBy}
            orderDirection={portManagementData.orderDirection}
            onRowSelectedChange={(port: PortModel, index: number, event: MouseEvent<HTMLElement>) => {
                var target = event.target as HTMLElement;
                if (target.tagName !== "BUTTON") {
                    dispatch(setSelectedPortIndex(index));
                    dispatch(setSelectedPortId(port.id));
                    dispatch(setPortInput(port));
                }
            }}
            selectedRowIndex={portManagementData.selectedIndex}
            stickyHeader={true}
        ></Datatable>
    </div>
};

export default PortManagementTable;